import styles from "./home.module.css";
import PlaceholderImage from "../../../Assets/defaultimg.png";
import defaultIMG from "../../../Assets/defaultimg.png";

const Banner = ({ images, speed = 5000 }) => {
  console.log(images)
  return (
    <div className={styles.ourPartnersinner}>
      <div className={styles.ourPartnerswrapper}>
        {[...Array(1)].map((_, index) => (
          <section style={{ "--speed": `${speed}ms` }} key={index}>
            {images.map(({ id, image, name, redirectLink }) => (
              <div className={styles.ourPartnersimage} key={id}>
                {/* Check if redirectLink exists and apply it as an anchor tag */}
                {redirectLink ? (
                  <a
                    href={redirectLink}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      src={image}
                      alt={`Partner: ${name}`}
                      onError={({ currentTarget }) => {
                        currentTarget.onerror = null;
                        currentTarget.src = defaultIMG;
                      }}
                      className={styles.Partnermain_img}
                    />
                  </a>
                ) : (
                  <img
                    src={image}
                    onError={({ currentTarget }) => {
                      currentTarget.onerror = null;
                      currentTarget.src = defaultIMG;
                    }}
                    alt={`Partner: ${name}`}
                    className={styles.Partnermain_img}
                  />
                )}
              </div>
            ))}
          </section>
        ))}
      </div>
    </div>
  );
};

export { Banner };
